import React from "react";
import {
  FaDownload,
  FaEye,
  FaSpinner,
  FaUpload,
  FaTelegramPlane
} from "react-icons/fa";
import styles from "./../../../assets/scss/custom.module.scss";
import PropTypes from "prop-types";

const ActionButton = ({ onClick, icon, tooltip, loading }) => (
  <button
    type="button"
    onClick={onClick}
    data-tooltip-id={tooltip}
    className={styles.btnPrimary}
    disabled={loading}
  >
    {loading ? <FaSpinner /> : icon}
  </button>
);
ActionButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.node,
  tooltip: PropTypes.string,
  loading: PropTypes.bool
};

const FileUploadInput = ({
  triggerFileUpload,
  fileUpload,
  fileInputRef,
  loading
}) => (
  <li>
    <ActionButton
      onClick={triggerFileUpload}
      tooltip="tooltip-upload"
      icon={<FaUpload />}
      loading={loading}
    />
    <input
      type="file"
      accept="application/pdf,image/*"
      onChange={fileUpload}
      ref={fileInputRef}
      hidden
    />
  </li>
);

FileUploadInput.propTypes = {
  triggerFileUpload: PropTypes.func.isRequired,
  fileUpload: PropTypes.func.isRequired,
  fileInputRef: PropTypes.any,
  loading: PropTypes.bool
};

const InvoiceActions = ({
  InvDetails,
  InvoiceDetails,
  loadSpin,
  triggerFileUpload,
  fileUpload,
  fileInputRef,
  messageShow,
  handleInvoiceUpload,
  handlePendingDownload
}) => {
  const status = InvDetails?.invoice?.externalInvoiceStatus;
  const file = InvDetails?.invoice?.invoiceFilePath;

  const isUserEntered =
    status === InvoiceDetails?.detailsSection?.btn?.manualCheck;

  const hasFile = Boolean(file);
  const isBulk = file?.includes("bulk_invoices");

  if (!isUserEntered) {
    return (
      <li key="download-btn">
        <ActionButton
          onClick={handlePendingDownload}
          tooltip="tooltip-download"
          icon={<FaDownload />}
          loading={loadSpin}
        />
      </li>
    );
  }

  if (hasFile && !isBulk) {
    return (
      <li key="view-btn">
        <ActionButton
          onClick={handlePendingDownload}
          tooltip="tooltip-viewUser"
          icon={<FaEye />}
          loading={loadSpin}
        />
      </li>
    );
  }

  return (
    <>
      <FileUploadInput
        triggerFileUpload={triggerFileUpload}
        fileUpload={fileUpload}
        fileInputRef={fileInputRef}
        loading={loadSpin}
      />

      {messageShow && (
        <li>
          <ActionButton
            onClick={handleInvoiceUpload}
            tooltip="tooltip-message"
            icon={<FaTelegramPlane />}
            loading={loadSpin}
          />
        </li>
      )}
    </>
  );
};

InvoiceActions.propTypes = {
  InvDetails: PropTypes.any,
  InvoiceDetails: PropTypes.any,
  loadSpin: PropTypes.bool,
  triggerFileUpload: PropTypes.func,
  fileUpload: PropTypes.func,
  fileInputRef: PropTypes.any,
  messageShow: PropTypes.bool,
  handleInvoiceUpload: PropTypes.func,
  handlePendingDownload: PropTypes.func
};

export default InvoiceActions;
